import Styles from './styles.module.css';
import React, { useState } from 'react';
import { doc, getFirestore, updateDoc } from 'firebase/firestore';
import { useAppSelector } from 'src/salon/app/hook';
import { targetData } from 'src/type';
import { useNavigate } from 'react-router-dom';
import { IoDocumentTextOutline, IoOpenOutline } from 'react-icons/io5';

type SchoolUnPublic = {
  companyId: string;
  year: string;
  target: targetData;
  setConfirm: React.Dispatch<React.SetStateAction<boolean>>;
};

const PDF_TARGETS = [
  { match: '専門(20歳卒)', label: '求人票（20歳卒）を確認する', age: '20' },
  { match: '高専(18歳卒)', label: '求人票（18歳卒）を確認する', age: '18' },
  { match: '高専(17歳卒)', label: '求人票（17歳卒）を確認する', age: '17' },
];

const SchoolUnPublic: React.FC<SchoolUnPublic> = ({ companyId, year, target, setConfirm }) => {

  const db = getFirestore();

  const navigate = useNavigate();

  const company = useAppSelector((state) => state.company.company);

  const [ uploading, setUploading ] = useState(false);

  const unPublic = async () => {
    setUploading(true);

    try {
      const ref = doc(db, "companies", company.id);

      await updateDoc(ref, {
        "progress.jobPostings": true,
      });

      navigate("/service/manual/sending");

    } catch (error) {
      console.error("unPublic failed:", error);

    } finally {
      setUploading(false);
    }
  };

  const pdfs = PDF_TARGETS.filter((p) => target.target.includes(p.match));
  const documentLabel = `${companyId}_${year}`;

  return (
    <>
    {uploading && (
      <div className={Styles.lockOverlay}>
        <div className={Styles.spinner} />
        <p>アップロード中...</p>
      </div>
    )}

    <div className={Styles.card}>
      <h4 className={Styles.title}>求人票の内容確認</h4>
      <p className={Styles.lead}>
        以下「求人票（○○歳卒）を確認する」より入力内容を確認し、問題がなければ確定ボタンを押して下さい。
      </p>

      <div className={Styles.pdfList}>
        {pdfs.map((p) => (
          <a
            key={p.age}
            className={Styles.pdfRow}
            href={`https://firebasestorage.googleapis.com/v0/b/trankllc-com.appspot.com/o/jobPostingsPdf%2F${documentLabel}_${p.age}.pdf?alt=media&token=`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <IoDocumentTextOutline className={Styles.pdfRow_icon} />
            <span className={Styles.pdfRow_label}>{p.label}</span>
            <IoOpenOutline className={Styles.pdfRow_ext} />
          </a>
        ))}
      </div>

      <div className={Styles.actions}>
        <button type="button" className={Styles.btnGhost} onClick={() => setConfirm(false)}>戻る</button>
        <button type="button" className={Styles.btnPrimary} onClick={() => unPublic()}>確定</button>
      </div>
    </div>
    </>
  );
}

export default SchoolUnPublic;
